<template>
    <v-container fluid>
            <!-- <v-layout row>                   
                    <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
                        <div data-aos="fade-down" data-aos-duration="1000">                            
                                <span style="font-size:70px;color:rgba(220,220,220,0.2)">Services</span>                       
                        </div>
                    </v-flex>                 
                </v-layout>  -->
            
            <span style="font-size:4vh">Our Services</span><hr>
           
        
        <v-container fluid>
            <v-layout row wrap> 
                <v-flex xs12 sm2 class="mt-5 pt-5 text-xs-center">
                    <span style="font-size:3vh;color:#1BB0E0" class="title">For public users</span>
                </v-flex>       
                 <v-flex xs12 sm3 offset-sm1>
                     <div data-aos="fade-up" data-aos-duration="1000">
                        <v-card class="mt-5 mr-3" flat>
                            <v-card-media
                            src="/static/pas.jpg"
                            height="200px">
                            </v-card-media>
                            <v-card-title>
                                <h3>View number of passengers</h3>
                                                               
                                   We use sonar technology to count the number of passengers.
                                   It will be updated on the web site(only for owners) and as well as in the mobile application when it starts to load passengers.
                                   So, anyone can check available number of seats of the current loading bus from our mobile app.
                                    If you're a highway bus owner, you can view number of passengers as well as speed, trip number and etc from the web site also.
                                
                                
                            </v-card-title>
                            
                        </v-card>
                     </div>
                </v-flex>

                <v-flex xs12 sm3 offset-sm1>
                    <div data-aos="fade-up" data-aos-duration="1000">
                        <v-card  class="mt-5 mr-3" flat>
                            <v-card-media
                            src="/static/tt.png"
                            height="200px"
                            contain>
                            </v-card-media>
                            <v-card-title>
                                <h3>View Timetable</h3>
                                    You can search timetable by the destination and time. 
                                    Then system will display you highway bus timetable and the availbale number of seats.
                            </v-card-title>
                           <!--  <v-card-actions>
                                <v-flex class="text-xs-center">
                                    <v-btn fab small outline color="primary">
                                        <v-icon>keyboard_arrow_down</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-card-actions> -->
                        </v-card>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
            <v-layout row style="height:50px">
                <v-flex xs12 class="text-xs-center">
                    
                </v-flex>
            </v-layout>

    

            <v-layout row wrap style="">

                <v-flex xs12 sm3 class="mt-5 pt-5">
                    <span style="font-size:3vh;color:#1BB0E0">For vehicle owners</span>
                </v-flex> 

                 <v-flex xs12 sm3>
                    <div data-aos="fade-up" data-aos-duration="1000">
                        <v-card class="mt-2 mr-3" flat>
                            <v-card-media
                            src="/static/map.png"
                            height="200px">
                            </v-card-media>
                            <v-card-title class="">
                                <h3 style="color:black">Live Track</h3>
                                    If you are a vehicle owner, you can view a live track of the vehicle by login to the account.
                                     You also can view details about number of passengers(only for Highway buses),
                                     speed and trip number which are updating frequently.
                            </v-card-title>
                            
                        </v-card>
                    </div>
                </v-flex>
            
                <v-flex xs12 sm3>
                    <div data-aos="fade-up" data-aos-duration="1000">
                        <v-card class="mt-2 mr-3" flat>
                            <v-card-media
                            src="/static/rep.jpg"
                            height="200px">
                            </v-card-media>
                            <v-card-title>
                                <h3>Get detailed reports</h3>
                                Vehcile owners can get detailed reports of fuel,income and profit.
                                These details can be view per week or per month as you wish.
                            </v-card-title>
                            
                        </v-card>
                    </div>
                </v-flex>

                 <v-flex xs12 sm3>
                    <div data-aos="fade-up" data-aos-duration="1000">
                        <v-card class="mt-2 mr-3" flat>
                            <v-card-media
                            src="/static/man.png"
                            height="200px"
                            contain>
                            </v-card-media>
                            <v-card-title class="">
                                <h3 style="color:black">Manage vehicle details</h3>
                                Vehcile owners have ability to manage details of vehicles. If you're an owner, 
                                you can add several number of vehicles, drivers to the account(Each vehicle should install a device).
                                You can add next Insurance,License,Service dates of each vehicle if you need.
                                Then the system will remind you about the dates that near to expire.
                            </v-card-title>
                            
                        </v-card>
                    </div>
                </v-flex>
            </v-layout>

            <v-layout row wrap style="height:100vh">
                <v-flex xs12>
                    <span style="font-size:4vh">Mobile Application</span><hr><br>
                        We provide 3 mobile applications for drivers, public users and vehicle owners<br><br>
                        <v-layout row>
                            <v-flex xs12 sm4>
                                <v-card flat class="grow">
                                    <v-card-media src="static/mobi.png" height="70vh" contain>
                                    </v-card-media>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-card flat class="grow">
                                    <v-card-media src="static/mobi.png" height="70vh" contain>
                                    </v-card-media>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-card flat class="grow">
                                    <v-card-media src="static/mobi.png" height="70vh" contain>
                                    </v-card-media>
                                </v-card>
                            </v-flex>
                        </v-layout>
                </v-flex>
            </v-layout>

            

    </v-container>
</template>

<script>
export default {
    data(){
        return{
           
    }
}
}
</script>


<style>
    .grow { transition: all .2s ease-in-out; }
    .grow:hover { transform: scale(1.1); }

.title{
        position: relative;
        bottom: 0;
        left:0;
        right: 0;
        top: 40%;
        padding-left:0;
    }
</style>


// WEBPACK FOOTER //
// src/components/MainPage/services.vue